import { ComplaintById, incidentLocationOptions } from "@modules/plaintes/plaintes.model.ts";
import React from "react";
interface ReportingComplaintProps {
  reportingComplaint: ComplaintById;
}
const ReportingComplaint: React.FC<ReportingComplaintProps> = ({
  reportingComplaint,
}) => {
  // const FormatHour = (date: Date) => {
  //   const hour = date.toString().split("T");
  //   return hour[1].toString().split(".")[0];
  // };
  const FormatLocation = (location: string) =>{
    const locationFormat = incidentLocationOptions.filter(loc => loc.code === location)
    return locationFormat[0].name
  }
  return (
    <div className="rounded-[10px] p-4 bg-white flex flex-col">
      <span className="text-black text-sm font-semibold mb-2">
        Explication de la plainte ou du signalement :
      </span>
      <div className="mb-3 text-sm break-all" style={{ lineHeight: "1.8" }}>
        {reportingComplaint.description}
      </div>
      <div className="w-full flex lg:flex-row flex-col items-baseline">
        <div className="gap-2 w-full lg:w-1/2 flex flex-col">
          <div className="flex items-baseline">
            <span className="text-[#6C757D] text-sm font-semibold">
              Date : &nbsp;
            </span>
            <span className="text-black text-sm">
              {new Date(reportingComplaint.incidentDate).toLocaleDateString()}
            </span>
          </div>
          <div className="flex items-baseline">
            <span className="text-[#6C757D] text-sm font-semibold">
              Lieu : &nbsp;
            </span>
            <span className="text-black text-sm">
              {reportingComplaint.incidentLocation
                ? FormatLocation(reportingComplaint.incidentLocation)
                : ""}
            </span>
          </div>
          <div className="flex items-baseline">
            <span className="text-[#6C757D] text-sm font-semibold">
              District : &nbsp;
            </span>
            <span className="text-black text-sm">
              {reportingComplaint.fokontany.municipality.district.name}
            </span>
          </div>
          <div className="flex items-baseline">
            <span className="text-[#6C757D] text-sm font-semibold">
              Fokotany : &nbsp;
            </span>
            <span className="text-black text-sm">
              {reportingComplaint.fokontany.name}
            </span>
          </div>
        </div>
        <div className="gap-2 w-full lg:w-1/2 flex flex-col">
          <div className="flex items-baseline">
            <span className="text-[#6C757D] text-sm font-semibold">
              Heure : &nbsp;
            </span>
            <span className="text-black text-sm">
              {reportingComplaint.incidentDate as string}
            </span>
          </div>
          <div className="flex items-baseline">
            <span className="text-[#6C757D] text-sm font-semibold">
              Région : &nbsp;
            </span>
            <span className="text-black text-sm">
              {reportingComplaint.fokontany.municipality.district.region.name}
            </span>
          </div>
          <div className="flex items-baseline">
            <span className="text-[#6C757D] text-sm font-semibold">
              Commune : &nbsp;
            </span>
            <span className="text-black text-sm">
              {reportingComplaint.fokontany.municipality.name}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportingComplaint;
